import keyBy from 'lodash-es/keyBy';
import { IOpenOrdersResponse, IOrder, IOrderMin } from '.';
import { OrderActionKeys as keys } from './orderActionKeys';
import { OrderActionTypes } from './orderActionTypes';

export interface IOrderState {
  hash: { [index: string]: IOrder };
  //openOrders: { [index: string]: { [index: number]: IOpenOrdersRedux } };
  openOrders: IOpenOrdersRedux;
  minOrderHash: { [index: string]: IOrderMin };
}

interface IOpenOrdersRedux {
  loading: boolean;
  //loadedAt?: Date;
  response?: IOpenOrdersResponse;
}

const initialState: IOrderState = {
  hash: {},
  minOrderHash: {},
  openOrders: { loading: false }
};

export function orderReducer(state: IOrderState = initialState, action: OrderActionTypes): IOrderState {
  switch (action.type) {
    case keys.FETCH_OPEN_ORDERS:
      return {
        ...state,
        openOrders: {
          ...state.openOrders,
          loading: true
        }
      };
    case keys.FETCH_ORDER_FULFILLED:
      return {
        ...state,
        hash: {
          ...state.hash,
          [action.payload.salesId]: action.payload
        }
      };
    case keys.SET_MIN_ORDERS:
      return {
        ...state,
        minOrderHash: {
          ...state.minOrderHash,
          ...keyBy(action.payload, (x: IOrderMin) => x.orderNumber)
        }
      };
    case keys.SET_OPEN_ORDERS:
      return {
        ...state,
        openOrders: {
          loading: false,
          response: action.payload.response
        }
      };
    default:
      return state;
  }
}
